/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';

/**
 *
 * @class SimpleSimAction
 *
 * @brief launch a simulation; used by the SimulateButtonComponent
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class SimpleSimAction extends Action {

  /* the callback invoke the simulation button */
  private clicker: () => void;

  constructor(
    clicker: () => void
  ) {

    super({
      key:   'window.simplesim',
      type:  ActionType.Window_SimpleSim,
      label: 'Launch Simple Simulation',
      icon:  '<i class="fas fa-tools"></i>',
      tip:   'Launch a Simple Simulation'
    });

    this.clicker = clicker;
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    this.clicker();

    return true;
  }
}
